import React, { Component, PropTypes } from "react";
import { connect } from "react-redux";
import { updateCheckoutMode } from "../../../actions/checkoutAppointmentStep";
import {
  menuNamesEnum,
  checkoutModesEnum,
  paymentModeEnum
} from "../../../state/initialState";
import {
  updateCheckoutAppointmentStepData,
  updateBookingToInvoice,
  chargeExistingCard,
  updateGettingStripeToken,
  changeTipPopupVisibility,
  updateInvoice,
  redeemGiftCertificate
} from "../../../actions/checkoutAppointmentStep";
import {
  decimalPoint
} from "../../../utils/helpers";
import {
  updateGlobalErrorMessage,
  removeGlobalErrorMessageIfMatchesThisString
} from "../../../actions/globalError";
import { updateGlobalSuccessMessage } from "../../../actions/globalSuccess";
import { forceValidation } from "../../shared/validMeReact";
import {
  updateCurrentMenu,
  updateGoBackFromCheckoutAndShowModal,
  updateZeroDollarModalVisibility
} from "../../../actions/menu";
import objectAssign from "object-assign";
import ConfirmZeroDollarModal from "../../shared/modals/confirmZeroDollarModal";

@connect(mapStateToProps)
export default class BottomPanelAppointmentCheckout extends Component {
  constructor(props) {
    super(props);
    this.state = { hoveredPayButton: false, hoverNextButton: false };
  }

  componentWillReceiveProps(props) {
    const { invoiceData, checkoutMode } = props;
    if (invoiceData.key) {
      if (
        invoiceData.status == "PAID" &&
        checkoutMode != checkoutModesEnum.PAYMENT_MODE
      ) {
        this.props.dispatch(updateCheckoutMode(checkoutModesEnum.PAYMENT_MODE));
      }
    }
  }

  handlePayButtonMouseIn = () => {
    this.setState({ hoveredPayButton: true });
  };

  handlePayButtonMouseOut = () => {
    this.setState({ hoveredPayButton: false });
  };

  handleNextCheckoutMouseIn = () => {
    this.setState({ hoverNextButton: true });
  };

  handleNextCheckoutMouseOut = () => {
    this.setState({ hoverNextButton: false });
  };

  dispatchUpdateCheckoutAppointmentStepData = data => {
    this.props.dispatch(updateCheckoutAppointmentStepData(data));
  };

  updateThisStep = data => {
    let newData = objectAssign(
      {},
      this.props.checkoutAppointmentStepData,
      data
    );
    this.dispatchUpdateCheckoutAppointmentStepData(newData);
  };

  canCheckoutCurrentBooking = () => {
    let { limitedPermissions, currentBookingId } = this.props;
    return (
      (limitedPermissions.canCheckoutAllBookings ||
        limitedPermissions.bookingsCheckoutableByCurrentUser.indexOf(
          currentBookingId
        ) > -1) &&
      this.canEditCurrentBooking()
    );
  };

  canEditCurrentBooking = () => {
    let { limitedPermissions, currentBookingId } = this.props;
    return (
      limitedPermissions.canEditAllBookings ||
      (limitedPermissions.bookingsEditableByCurrentUser.indexOf(
        currentBookingId
      ) > -1 &&
        currentBookingId)
    );
  };

  changeCheckoutMode = checkoutMode => {
    const { posSettings, invoiceData } = this.props;
    let enabledToCheckout = this.canCheckoutCurrentBooking();

    if (enabledToCheckout && checkoutMode == checkoutModesEnum.PAYMENT_MODE) {
      if (
        posSettings &&
        posSettings.tipssettings &&
        posSettings.tipssettings.enabled &&
        invoiceData.status != "PAID" &&
        invoiceData.gratuityamount == 0
      ) {
        this.props.dispatch(changeTipPopupVisibility(true));
      }
    }
    this.props.dispatch(updateCheckoutMode(checkoutMode));
  };

  goBackFromCheckout = () => {
    const { invoiceData } = this.props;
    if (invoiceData.status == "PAID" || invoiceData.balanceamount > 0) {
      this.props.dispatch(updateCurrentMenu(this.props.checkoutPreviousMenu));
      this.props.dispatch(updateGlobalErrorMessage("")); //remove all checkout related errors
      this.props.dispatch(updateCheckoutMode(checkoutModesEnum.VIEW_MODE));
    } else {
      this.props.dispatch(updateGoBackFromCheckoutAndShowModal(true));
    }
  };

  doPaymentOnExistingCard = (chargeAmount, cb) => {
    const { currentBookingId } = this.props;
    const payload = { chargeamount: chargeAmount };
    this.props.dispatch(chargeExistingCard(currentBookingId, payload, cb));
  };

  payInvoiceHandler = () => {
    const {
      currentBookingId,
      checkoutAppointmentStepData,
      paymentMode,
      invoiceData,
      bookingPaymentsData,
      foundGiftCertData
    } = this.props;
    let { PaymentSuccessfulMessage } = window.APP.LANGUAGE.Success;
    let cb = () => {
      this.props.dispatch(
        updateGlobalSuccessMessage({
          message: PaymentSuccessfulMessage,
          icon: "saved_icon"
        })
      );
    };
    if (currentBookingId) {
      const chargeAmount = Number(checkoutAppointmentStepData.paymentAmount);
      if (paymentMode == paymentModeEnum.CASH_MODE) {
        const payload = { chargeamount: chargeAmount };
        this.props.dispatch(
          updateBookingToInvoice(currentBookingId, payload, cb)
        );
      } else if (paymentMode == paymentModeEnum.CARD_MODE) {
        let offlineCardPayment = null;
        if (bookingPaymentsData && bookingPaymentsData.payments) {
          offlineCardPayment = bookingPaymentsData.payments.find(payment => {
            return payment.card.cardpresent === false;
          });
        }
        if (offlineCardPayment) {
          this.doPaymentOnExistingCard(chargeAmount, cb);
        } else {
          this.updateThisStep({
            doCreditCardFormPayment: true
          });
        }
      } else if (paymentMode == paymentModeEnum.GIFT_MODE) {
        const redemptionAmount = Number(
          checkoutAppointmentStepData.giftCertRedemptionAmount
        );
        const payload = {
          invoicekey: invoiceData.key,
          value: redemptionAmount 
        };
        this.props.dispatch(
          redeemGiftCertificate(foundGiftCertData.key, payload)
        );
      }
    }
  };

  nextButtonHandler = () => {
    const { invoiceData } = this.props;
    if ( invoiceData.totalamount > 0 )  {
      this.transitionToPaymentMode(); 
    } else {
      this.props.dispatch(updateZeroDollarModalVisibility(true));
    }
  }

  transitionToPaymentMode = () => {
    const { invoiceData, posSettings } = this.props;
    let { AmountCannotBeGreater, InvoiceCantBeOverpaid } = window.APP.LANGUAGE.Errors;

    if (
      invoiceData.key &&
      invoiceData.outstandingamount == 0 &&
      posSettings &&
      posSettings.tipssettings.enabled == false
    ) {
      const formattedDueDate =
        invoiceData.duedate.length > 9
          ? invoiceData.duedate
          : invoiceData.duedate.replace("Z", "T000000Z");
      let payload = {
        status: "PAID",
        customerid: invoiceData.customerid,
        duedate: formattedDueDate,
        items: []
      };
      invoiceData.items.map(invoiceItem => {
        let payloadItem = {};
        payloadItem.amount = invoiceItem.amount;
        if (invoiceItem.type) {
          payloadItem.type = invoiceItem.type;
        }
        if (invoiceItem.description) {
          payloadItem.description = invoiceItem.description;
        }
        if (invoiceItem.amounttype) {
          payloadItem.amounttype = invoiceItem.amounttype;
        }
        if (invoiceItem.reference) {
          payloadItem.reference = invoiceItem.reference;
        }
        if (invoiceItem.tax) {
          payloadItem.taxkey = invoiceItem.tax.key;
        }
        if (invoiceItem.count) {
          payloadItem.count = invoiceItem.count;
        }
        payload.items.push(payloadItem);
      });
      this.props.dispatch(updateInvoice(invoiceData.key, payload));
    }
    if (invoiceData.key) {
      this.updateThisStep({
        paymentAmount: decimalPoint(invoiceData.outstandingamount + "")
      });
    }

    this.props.dispatch(
      removeGlobalErrorMessageIfMatchesThisString(InvoiceCantBeOverpaid)
    );

    this.props.dispatch(
      removeGlobalErrorMessageIfMatchesThisString(AmountCannotBeGreater)
    );

    this.changeCheckoutMode(checkoutModesEnum.PAYMENT_MODE);
  };

  closeForm = () => {
    let event = new CustomEvent("messageFromUsToParent", {
      detail: {
        action: "close"
      }
    });
    window.dispatchEvent(event);
  };

  render() {
    let {
      PayButtonText,
      NextButtonText,
      BackButtonText,
      DoneButtonText,
      BookingCannotBeProcessedByCurrentUser,
      NextcheckoutMessage
    } = window.APP.LANGUAGE.Pages.AppointmentCheckout;

    let {
      checkoutMode,
      invoiceData,
      foundGiftCertData,
      bookingPaymentsData,
      appointmentStepData: { paymentsEnabled }
    } = this.props;
    const {
      nameOnCard,
      cardNumberValid,
      cardExpValid,
      cardCvvValid,
      paymentAmount,
      giftCertRedemptionAmount
    } = this.props.checkoutAppointmentStepData;
    const {
      isEditingServicePrice,
      isNewPriceLessThanInvoicePaid
    } = this.props.checkoutAppointmentStepData;
    const paymentAmountNumber = Number(paymentAmount);
    let backCheckoutButton = "";

    const existingOfflineCard = () => {
      if (bookingPaymentsData && bookingPaymentsData.payments) {
        const offlineCardPayment = bookingPaymentsData.payments.find(
          payment => {
            return payment.card.cardpresent === false;
          }
        );
        if (offlineCardPayment) {
          return true;
        }
      }
      return false;
    };

    let disabled = !this.canCheckoutCurrentBooking();
    let payButtonEnabled = false;

    if (this.props.paymentMode == paymentModeEnum.CASH_MODE) {
      payButtonEnabled = !disabled && paymentAmountNumber > 0;
    } else if (this.props.paymentMode == paymentModeEnum.CARD_MODE) {
      payButtonEnabled =
        !disabled &&
        paymentAmountNumber > 0 &&
        ((nameOnCard && cardNumberValid && cardExpValid && cardCvvValid) || existingOfflineCard());
    } else if (this.props.paymentMode == paymentModeEnum.GIFT_MODE) {
      payButtonEnabled =
        !disabled && foundGiftCertData != null && giftCertRedemptionAmount > 0;
    }

    let actionButton = "";
    if (checkoutMode == checkoutModesEnum.VIEW_MODE && paymentsEnabled) {
      backCheckoutButton = (
        <a
          className="ui left floated  booking_cancel"
          onClick={this.goBackFromCheckout}
        >
          {BackButtonText}
        </a>
      );
      if (isEditingServicePrice) {
        actionButton = (
          <div
            data-group="checkoutAppointmentStep&paymentDetailsStep"
            className="ui disabled right floated button btn-default"
          >
            {NextButtonText}
          </div>
        );
      } else if (isNewPriceLessThanInvoicePaid) {
        actionButton = (
          <div className="tooltip-container">
            <div
              data-group="checkoutAppointmentStep&paymentDetailsStep"
              onMouseOver={this.handleNextCheckoutMouseIn}
              onMouseOut={this.handleNextCheckoutMouseOut}
              className="ui disabled right floated button btn-default"
            >
              {NextButtonText}
            </div>
            {this.state.hoverNextButton ? (
              <div className="booking_tooltip_text savebtn">
                {NextcheckoutMessage}
              </div>
            ) : (
              ""
            )}
          </div>
        );
      } else {
        actionButton = (
          <div
            onClick={this.nextButtonHandler}
            data-group="checkoutAppointmentStep&paymentDetailsStep"
            className="ui right floated button btn-default"
          >
            {NextButtonText}
          </div>
        );
      }
    } else if (
      checkoutMode == checkoutModesEnum.VIEW_MODE &&
      !paymentsEnabled
    ) {
      backCheckoutButton = (
        <a
          className="ui left floated  booking_cancel"
          onClick={this.goBackFromCheckout}
        >
          {BackButtonText}
        </a>
      );
    } else if (paymentsEnabled) {
      if (!disabled && invoiceData.key && invoiceData.status == "PAID") {
        backCheckoutButton = <br />;
        actionButton = (
          <div
            onClick={this.closeForm}
            data-group="checkoutAppointmentStep&paymentDetailsStep"
            className="ui right floated button btn-default"
          >
            {DoneButtonText}
          </div>
        );
      } else {
        backCheckoutButton = (
          <a
            className="ui left floated  booking_cancel"
            onClick={this.goBackFromCheckout}
          >
            {BackButtonText}
          </a>
        );
        if (payButtonEnabled) {
          actionButton = (
            <div
              onClick={this.payInvoiceHandler}
              data-group="checkoutAppointmentStep&paymentDetailsStep"
              className="ui right floated button btn-default"
            >
              {PayButtonText}
            </div>
          );
        } else {
          actionButton = (
            <div className="tooltip-container">
              <div
                onMouseOver={this.handlePayButtonMouseIn}
                onMouseOut={this.handlePayButtonMouseOut}
                className="ui disable right floated button btn-default"
              >
                {PayButtonText}
              </div>
              {this.state.hoveredPayButton ? (
                <div className="booking_tooltip_text savebtn">
                  {BookingCannotBeProcessedByCurrentUser}
                </div>
              ) : (
                ""
              )}
            </div>
          );
        }
      }
    }

    return (
      <div className="ui clearing aligned booking_footer">
        <ConfirmZeroDollarModal onConfirm={this.transitionToPaymentMode} />
        {backCheckoutButton}
        <div className="action_buttons">{actionButton}</div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    currentBookingId: state.bookingReducer.currentBookingId,
    paymentMode: state.appointmentCheckoutReducer.paymentMode,
    checkoutMode: state.appointmentCheckoutReducer.checkoutMode,
    limitedPermissions: state.appointmentStepReducer.limitedPermissions,
    posSettings: state.appointmentCheckoutReducer.posSettings,
    invoiceData: state.appointmentCheckoutReducer.invoiceData,
    foundGiftCertData: state.appointmentCheckoutReducer.foundGiftCertData,
    appointmentStepData: state.appointmentStepReducer.appointmentStepData,
    bookingPaymentsData: state.appointmentCheckoutReducer.bookingPaymentsData,
    checkoutAppointmentStepData:
      state.appointmentCheckoutReducer.checkoutAppointmentStepData,
    checkoutPreviousMenu: state.menuReducer.checkoutPreviousMenu
  };
}
